<template>
  <div class="FollowUpManage" :class="{ 'vertical-layout': layout === 'vertical' }">    <!-- 顶部查询条件 -->
    <div class="top-search-box">
      <el-form :model="queryConditionForm" label-width="90px" size="mini" inline>
        <el-form-item label="患者名称:">
          <el-input v-model="queryConditionForm.patientName" placeholder="请输入患者名称" @keyup.enter.native="handleSearch" style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="随访状态:">
          <el-select v-model="queryConditionForm.status" placeholder="请选择" @change="handleSearch" clearable style="width: 120px">
            <el-option label="未执行" :value="1"></el-option>
            <el-option label="执行中" :value="2"></el-option>
            <el-option label="执行完成" :value="3"></el-option>
            <el-option label="超期" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间:">
          <el-date-picker v-model="dateRange[0]" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 160px"></el-date-picker>
          <span style="margin: 0 5px">-</span>
          <el-date-picker v-model="dateRange[1]" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 160px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch">搜索</el-button>
          <el-button type="warning" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 下方左右布局 -->
    <div class="main-layout">
      <!-- 左侧 - 使用 Tab 包装 -->
      <div class="left-panel">
        <el-tabs type="border-card" class="left-tabs">
          <el-tab-pane label="随访列表">
            <div class="table-container">
              <el-table
                  :data="tableData"
                  border
                  @row-click="handleRowClick"
                  highlight-current-row
                  v-loading="loading"
                  height="100%">
                <el-table-column
                    v-for="col in tableColumns"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    align="center"
                    :min-width="col.width">
                  <template #default="{ row }">
                    <span v-if="col.prop === 'status'">
                      <el-tag :type="getStatusType(row.status)" size="mini">{{ getStatusText(row.status) }}</el-tag>
                    </span>
                    <span v-else-if="col.prop === 'type'">
                      {{ getTypeText(row.type) }}
                    </span>
                    <span v-else-if="col.prop === 'exeInfo'">
                      {{ row.exeNum || 0 }} / {{ row.num || 0 }}
                    </span>
                    <span v-else>{{ row[col.prop] || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="150" align="center">
                  <template #default="{ row }">
                    <el-button type="primary" size="mini" @click.stop="handleEdit(row)">修改</el-button>
                    <el-button type="warning" size="mini" @click.stop="handleExecute(row)">执行</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-wrapper">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[8, 16, 24]"
                    :page-size="pageSize"
                    :total="totalSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background>
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 右侧详情 -->
      <div class="right-panel">
        <el-tabs v-model="activeRightTab" type="border-card" class="right-tabs">
<!--          <el-tab-pane label="基本信息" name="basic">
            <div class="info-form">
              <el-form :model="detailForm" label-width="100px" size="small" label-position="left" :disabled="true">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="患者ID:"><span>{{ detailForm.patientId || '-' }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="患者名称:"><span>{{ detailForm.patientName || '-' }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="就诊ID:"><span>{{ detailForm.seeId || '-' }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话:"><span>{{ detailForm.tel || '-' }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="随访类型:"><span>{{ getTypeText(detailForm.type) }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="执行状态:"><el-tag :type="getStatusType(detailForm.status)" size="small">{{ getStatusText(detailForm.status) }}</el-tag></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="执行人:"><span>{{ getDoctorNameById(detailForm.exeId) }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="创建人:"><span>{{ getDoctorNameById(detailForm.createId) }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="执行次数:"><span>{{ detailForm.exeNum || 0 }} / {{ detailForm.num || 0 }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="间隔天数:"><span>{{ detailForm.intervalDay || '-' }} 天</span></el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="说明:"><span>{{ detailForm.describ || '-' }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="创建时间:"><span>{{ detailForm.createTime || '-' }}</span></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="开始时间:"><span>{{ detailForm.startTime || '-' }}</span></el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>-->

          <el-tab-pane label="随访记录" name="followRecord">
            <div class="table-wrapper">
              <el-table :data="followRecordList" border v-loading="followRecordLoading" height="100%">
                <el-table-column prop="createName" label="创建人" min-width="100" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="160" align="center"></el-table-column>
                <el-table-column prop="describ" label="执行描述" min-width="200" show-overflow-tooltip></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="就诊信息" name="seeInfo">
            <div v-loading="seeInfoLoading" class="see-info-container">
              <template v-if="seeInfoData">
                <!-- 就诊基本信息 -->
                <div class="see-info-section">
                  <el-row :gutter="20">
                    <el-col :span="6"><div class="info-item"><span class="label">患者名称：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.patientName || '-' }}</span></div></el-col>
                    <el-col :span="6"><div class="info-item"><span class="label">性别：</span><span class="value">{{ getGenderText(seeInfoData.cncSeeDoctorRespVO?.gender) }}</span></div></el-col>
                    <el-col :span="6"><div class="info-item"><span class="label">年龄：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.age || '-' }}</span></div></el-col>
                    <el-col :span="6"><div class="info-item"><span class="label">健康卡号：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.patNo || '-' }}</span></div></el-col>
                    <el-col :span="6"><div class="info-item"><span class="label">身份证号：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.cardid || '-' }}</span></div></el-col>
                    <el-col :span="6"><div class="info-item"><span class="label">联系电话：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.tel || '-' }}</span></div></el-col>
                    <el-col :span="6"><div class="info-item"><span class="label">联系人：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.conerName || '-' }}</span></div></el-col>
                    <el-col :span="6"><div class="info-item"><span class="label">联系人电话：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.conerTel || '-' }}</span></div></el-col>
                    <el-col :span="12"><div class="info-item"><span class="label">主诉：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.patientTell || '-' }}</span></div></el-col>
                    <el-col :span="12"><div class="info-item"><span class="label">现病史：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.nowHistory || '-' }}</span></div></el-col>
                    <el-col :span="12"><div class="info-item"><span class="label">既往史：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.beforeHistory || '-' }}</span></div></el-col>
                    <el-col :span="12"><div class="info-item"><span class="label">诊疗意见：</span><span class="value">{{ seeInfoData.cncSeeDoctorRespVO?.diagnosisAdvice || '-' }}</span></div></el-col>
                  </el-row>
                </div>

                <!-- 门诊诊断 -->
                <div class="see-info-section" v-if="seeInfoData.cncDiagnosisRespVOList?.length > 0">
                  <el-table :data="seeInfoData.cncDiagnosisRespVOList" border stripe size="small">
                    <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                    <el-table-column prop="diagnosticName" label="诊断名称" min-width="200"></el-table-column>
                    <el-table-column prop="diagnosticCategory" label="诊断类别" width="100" align="center">
                      <template #default="{ row }"><span>{{ row.diagnosticCategory === '1' ? '西医' : '中医' }}</span></template>
                    </el-table-column>
                  </el-table>
                </div>

                <!-- 门诊医嘱 -->
                <div class="see-info-section" v-if="seeInfoData.dugDoctorAdviceRespVOList?.length > 0">
                  <el-table :data="seeInfoData.dugDoctorAdviceRespVOList" border stripe size="small">
                    <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                    <el-table-column prop="orderType" label="单据类型" width="100" align="center">
                      <template #default="{ row }"><span>{{ getOrderTypeText(row.orderType) }}</span></template>
                    </el-table-column>
                    <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="doctorName" label="开单医生" width="120" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>
                  </el-table>
                </div>

                <!-- 如果没有门诊诊断和医嘱 -->
                <div v-if="seeInfoData.cncDiagnosisRespVOList?.length === 0 && seeInfoData.dugDoctorAdviceRespVOList?.length === 0" class="empty-tip">
                  暂无诊断和医嘱信息
                </div>
              </template>
              <div v-if="!seeInfoData && !seeInfoLoading" class="empty-tip">暂无就诊信息</div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="患者档案" name="patientInfo">
            <div v-loading="patientInfoLoading" class="patient-info-container">
              <div class="patient-info-header">
                <el-button type="primary" size="mini" @click="togglePatientInfoEdit" v-if="!patientInfoEditMode">编辑</el-button>
                <span v-else>
                  <el-button type="success" size="mini" @click="savePatientInfo" :loading="patientInfoSaving">保存</el-button>
                  <el-button size="mini" @click="cancelPatientInfoEdit">取消</el-button>
                </span>
              </div>
              <el-form :model="patientInfoForm" :rules="patientInfoRules" ref="patientInfoForm" label-width="110px" size="small" :disabled="!patientInfoEditMode">
                <el-row :gutter="20">
                  <el-col :span="8"><el-form-item label="姓名:" prop="name"><el-input v-model="patientInfoForm.name"></el-input></el-form-item></el-col>
                  <el-col :span="8"><el-form-item label="性别:" prop="sex"><el-select v-model="patientInfoForm.sex" style="width:100%"><el-option label="男" :value="1"></el-option><el-option label="女" :value="2"></el-option></el-select></el-form-item></el-col>
                  <el-col :span="8"><el-form-item label="联系电话:" prop="tel"><el-input v-model="patientInfoForm.tel"></el-input></el-form-item></el-col>
                  <el-col :span="8"><el-form-item label="健康卡号:" prop="patId"><el-input v-model="patientInfoForm.patId"></el-input></el-form-item></el-col>
                  <el-col :span="8"><el-form-item label="证件类型:" prop="certType"><el-select v-model="patientInfoForm.certType" filterable style="width:100%"><el-option v-for="item in certypeOption" :key="item.id" :label="item.label" :value="item.id"></el-option></el-select></el-form-item></el-col>
                  <el-col :span="8"><el-form-item label="证件号码:" prop="certno"><el-input v-model="patientInfoForm.certno" @blur="handleIdCardParse"></el-input></el-form-item></el-col>
                  <el-col :span="8"><el-form-item label="联系人姓名:" prop="conerName"><el-input v-model="patientInfoForm.conerName"></el-input></el-form-item></el-col>
                  <el-col :span="8"><el-form-item label="联系人电话:" prop="conerTel"><el-input v-model="patientInfoForm.conerTel"></el-input></el-form-item></el-col>
                  <el-col :span="24"><el-form-item label="联系地址:" prop="conerAddName"><el-input v-model="patientInfoForm.conerAddName"></el-input></el-form-item></el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="随访执行" :visible.sync="executeDialogVisible" width="30%" :close-on-click-modal="false" @close="handleExecuteClose">
      <el-form :model="executeForm" :rules="executeRules" ref="executeForm" label-width="100px" size="small">
        <el-form-item label="执行描述:" prop="describ">
          <el-input type="textarea" v-model="executeForm.describ" placeholder="请输入执行描述" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitExecute" :loading="executeLoading">确 定</el-button>
        <el-button size="mini" @click="executeDialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="formDialogVisible" width="40%" :close-on-click-modal="false" @close="handleDialogClose">
      <el-form :model="formData" :rules="formRules" ref="followForm" label-width="100px" size="small">
        <el-row :gutter="20">
          <el-col :span="12"><el-form-item label="患者ID:" prop="patientId"><el-input v-model="formData.patientId" type="number"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="就诊ID:" prop="seeId"><el-input v-model="formData.seeId" type="number"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="随访类型:" prop="type"><el-select v-model="formData.type" style="width:100%"><el-option label="复诊提醒" :value="1"></el-option><el-option label="疗程提醒" :value="2"></el-option><el-option label="慢病随访" :value="3"></el-option><el-option label="用药提醒" :value="4"></el-option><el-option label="其他" :value="5"></el-option></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="执行人:" prop="exeId"><el-select v-model="formData.exeId" filterable style="width:100%"><el-option v-for="item in doctorOptions" :key="item.id" :label="item.label" :value="item.id"></el-option></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="执行次数:" prop="num"><el-input-number v-model="formData.num" :min="1" :max="999" controls-position="right" style="width:100%"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="间隔天数:" prop="intervalDay"><el-input-number v-model="formData.intervalDay" :min="0" :max="365" controls-position="right" style="width:100%"></el-input-number></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="说明:" prop="describ"><el-input type="textarea" v-model="formData.describ" :rows="3"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
        <el-button size="mini" @click="formDialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { followPage, followAdd, followUpdate, followExeRecord, followDetail, getFollowDetailById } from "@/api/FollowUpClinic/FollowUpClinic";
import { getPatientAllData, getDocphrList } from "@/api/reservation/outpatientPhysician";
import { updateDocphr } from "@/api/reservation/healthrecords";
import { dict } from "@/api";

export default {
  name: "FollowUpManage",
  props: {
    layout: {
      type: String,
      default: 'horizontal',  // horizontal | vertical
      validator: (val) => ['horizontal', 'vertical'].includes(val)
    }
  },
  data() {
    return {
      queryConditionForm: { patientName: '', status: null },
      dateRange: [],
      loading: false,

      activeRightTab: 'followRecord',
      activeSeeInfoTab: 'basic',

      followRecordList: [],
      followRecordLoading: false,

      certypeOption: [],

      pageNum: 1,
      pageSize: 8,
      totalSize: 0,
      tableData: [],
      tableColumns: [
        { prop: 'patientName', label: '患者名称', width: 100 },
        { prop: 'type', label: '随访类型', width: 100 },
        { prop: 'status', label: '执行状态', width: 90 },
        { prop: 'exeName', label: '执行人', width: 90 },
        { prop: 'exeInfo', label: '已执行/总次数', width: 120 },
        { prop: 'intervalDay', label: '间隔天数', width: 100 },
        { prop: 'startTime', label: '开始时间', width: 160 },
        { prop: 'createTime', label: '创建时间', width: 160 },
        { prop: 'describ', label: '说明', width: 200 }
      ],

      detailForm: {},
      currentRowId: null,

      executeDialogVisible: false,
      executeLoading: false,
      executeForm: { followId: null, describ: '' },
      executeRules: { describ: [{ required: true, message: '请输入执行描述', trigger: 'blur' }] },

      formDialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      submitLoading: false,
      formData: { id: null, patientId: null, seeId: null, type: null, exeId: null, num: 1, intervalDay: 0, describ: '' },
      formRules: {
        patientId: [{ required: true, message: '请输入患者ID', trigger: 'blur' }],
        seeId: [{ required: true, message: '请输入就诊ID', trigger: 'blur' }],
        type: [{ required: true, message: '请选择随访类型', trigger: 'change' }],
        exeId: [{ required: true, message: '请选择执行人', trigger: 'change' }],
        num: [{ required: true, message: '请输入执行次数', trigger: 'blur' }]
      },

      seeInfoLoading: false,
      seeInfoData: null,

      patientInfoLoading: false,
      patientInfoEditMode: false,
      patientInfoSaving: false,
      patientInfoForm: { id: null, name: '', sex: null, brdy: '', certType: 0, certno: '', tel: '', patId: '', conerAddName: '', conerName: '', conerTel: '', conerRltsId: '' },
      patientInfoRules: { name: [{ required: true, message: '请输入姓名', trigger: 'blur' }], sex: [{ required: true, message: '请选择性别', trigger: 'change' }] },
      currentPatientId: null
    };
  },
  computed: {
    doctorOptions() { return this.$store.getters['preload/getDoctorListOptions'] || []; }
  },
  mounted() {
    this.loadDictData();
    this.loadData();
    this.clearRightData();
  },
  methods: {
    clearRightData() {
      this.detailForm = {};
      this.followRecordList = [];
      this.seeInfoData = null;
      this.patientInfoForm = { id: null, name: '', sex: null, brdy: '', certType: 0, certno: '', tel: '', patId: '', conerAddName: '', conerName: '', conerTel: '', conerRltsId: '' };
      this.currentRowId = null;
    },

    async loadDictData() {
      try {
        const res = await dict();
        this.certypeOption = (res.data.certypeEntities || []).map(item => ({ id: item.id, label: item.name }));
      } catch (error) { console.error('字典数据加载失败:', error); }
    },

    async loadData() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          patientName: this.queryConditionForm.patientName || undefined,
          status: this.queryConditionForm.status || undefined,
          startTime: this.dateRange?.[0] || undefined,
          endTime: this.dateRange?.[1] || undefined
        };
        const res = await followPage(params);
        if (res.code === 200 || res.code === 0) {
          const data = res.data;
          this.tableData = data.content || [];
          this.totalSize = data.totalSize || 0;
        }
      } catch (error) { console.error('加载失败:', error); this.$message.error('网络错误'); }
      finally { this.loading = false; }
    },

    // 加载基本信息
    async loadBasicInfo(followId) {
      try {
        const res = await followDetail(followId);
        if (res.code === 200) {
          this.detailForm = res.data || {};
        }
      } catch (error) {
        console.error('加载基本信息失败:', error);
      }
    },

    // 加载随访记录
    async loadFollowRecord(followId) {
      this.followRecordLoading = true;
      try {
        const res = await getFollowDetailById(followId);
        if (res.code === 200) {
          this.followRecordList = res.data || [];
        } else {
          this.followRecordList = [];
        }
      } catch (error) {
        console.error('加载随访记录失败:', error);
        this.followRecordList = [];
      } finally {
        this.followRecordLoading = false;
      }
    },

    // 加载就诊信息
    // 加载就诊信息
    async loadSeeInfo(seeId) {
      if (!seeId) {
        this.seeInfoData = null;
        return;
      }
      this.seeInfoLoading = true;
      try {
        const res = await getPatientAllData({ id: seeId });
        console.log('就诊信息返回:', res);
        if (res.code === 200 && res.data) {
          // 直接赋值整个 data 对象
          this.seeInfoData = res.data;
          console.log('seeInfoData 赋值成功:', this.seeInfoData);
          console.log('门诊医嘱列表:', this.seeInfoData?.dugDoctorAdviceRespVOList);
        } else {
          this.seeInfoData = null;
        }
      } catch (error) {
        console.error('加载就诊信息失败:', error);
        this.seeInfoData = null;
      } finally {
        this.seeInfoLoading = false;
      }
    },

    // 加载患者档案
    async loadPatientInfo(patientId) {
      if (!patientId) {
        this.patientInfoForm = { id: null, name: '', sex: null, brdy: '', certType: 0, certno: '', tel: '', patId: '', conerAddName: '', conerName: '', conerTel: '', conerRltsId: '' };
        return;
      }
      this.patientInfoLoading = true;
      try {
        const res = await getDocphrList(patientId);
        if (res.code === 200 && res.data) {
          const data = res.data;
          this.patientInfoForm = {
            id: data.id,
            name: data.name || '',
            sex: data.sex,
            brdy: data.brdy || '',
            certType: data.certType || 0,
            certno: data.certno || '',
            tel: data.tel || '',
            patId: data.patId || '',
            conerAddName: data.conerAddName || '',
            conerName: data.conerName || '',
            conerTel: data.conerTel || '',
            conerRltsId: data.conerRltsId || ''
          };
        }
      } catch (error) {
        console.error('加载患者档案失败:', error);
      } finally {
        this.patientInfoLoading = false;
      }
    },

    // 点击行 - 加载所有数据
    async handleRowClick(row) {
      if (this.currentRowId === row.id) return;
      this.currentRowId = row.id;

      // 并行加载所有数据
      await Promise.all([
        this.loadBasicInfo(row.id),
        this.loadFollowRecord(row.id),
        this.loadSeeInfo(row.seeId),
        this.loadPatientInfo(row.patientId)
      ]);
    },

    // 切换标签页时，如果当前有选中的行，重新加载对应数据
    async handleTabChange(tabName) {
      if (!this.currentRowId) return;

      // 根据切换的标签页重新加载对应数据
      switch (tabName) {
        case 'basic':
          await this.loadBasicInfo(this.currentRowId);
          break;
        case 'followRecord':
          await this.loadFollowRecord(this.currentRowId);
          break;
        case 'seeInfo':
          const currentRow = this.tableData.find(r => r.id === this.currentRowId);
          if (currentRow) {
            await this.loadSeeInfo(currentRow.seeId);
          }
          break;
        case 'patientInfo':
          const row = this.tableData.find(r => r.id === this.currentRowId);
          if (row) {
            await this.loadPatientInfo(row.patientId);
          }
          break;
      }
    },

    handleIdCardParse() {
      const idCard = this.patientInfoForm.certno;
      if (!idCard || idCard.length !== 18) return;
      const idCard18Regex = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      if (!idCard18Regex.test(idCard)) { this.$message.warning('请输入正确的18位身份证号码'); return; }
      this.patientInfoForm.brdy = `${idCard.slice(6, 10)}-${idCard.slice(10, 12)}-${idCard.slice(12, 14)}`;
      const genderCode = parseInt(idCard.slice(16, 17));
      this.patientInfoForm.sex = genderCode % 2 === 1 ? 1 : 2;
      this.$message.success('身份证识别成功');
    },

    togglePatientInfoEdit() { this.patientInfoEditMode = true; },
    cancelPatientInfoEdit() { this.patientInfoEditMode = false; this.loadPatientInfo(this.currentPatientId); },

    async savePatientInfo() {
      try { await this.$refs.patientInfoForm.validate(); } catch (error) { this.$message.warning('请填写完整信息'); return; }
      this.patientInfoSaving = true;
      try {
        const res = await updateDocphr(this.patientInfoForm);
        if (res.code === 200 || res.code === 0) {
          this.$message.success('保存成功');
          this.patientInfoEditMode = false;
        } else { this.$message.error(res.message || '保存失败'); }
      } catch (error) { console.error('保存失败:', error); this.$message.error('网络错误'); }
      finally { this.patientInfoSaving = false; }
    },

    handleExecute(row) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      if (row.exeId !== userInfo.staffId) { this.$message.warning('只有指定的执行人才能执行'); return; }
      this.executeForm = { followId: row.id, describ: '' };
      this.executeDialogVisible = true;
    },

    async submitExecute() {
      try { await this.$refs.executeForm.validate(); } catch (error) { this.$message.warning('请填写执行描述'); return; }
      this.executeLoading = true;
      try {
        const res = await followExeRecord(this.executeForm);
        if (res.code === 200 || res.code === 0) {
          this.$message.success('执行成功');
          this.executeDialogVisible = false;
          await this.loadData();
          if (this.currentRowId) {
            await this.loadBasicInfo(this.currentRowId);
            await this.loadFollowRecord(this.currentRowId);
          }
        } else { this.$message.error(res.message || '执行失败'); }
      } catch (error) { this.$message.error('网络错误'); }
      finally { this.executeLoading = false; }
    },
    handleExecuteClose() { this.executeForm = { followId: null, describ: '' }; },

    handleAdd() {
      this.dialogTitle = '新增随访';
      this.isEdit = false;
      this.formData = { id: null, patientId: null, seeId: null, type: null, exeId: null, num: 1, intervalDay: 0, describ: '' };
      this.formDialogVisible = true;
    },

    async handleEdit(row) {
      try {
        const res = await followDetail(row.id);
        if (res.code === 200 || res.code === 0) {
          const data = res.data;
          this.dialogTitle = '修改随访';
          this.isEdit = true;
          this.formData = { id: data.id, patientId: data.patientId, seeId: data.seeId, type: data.type, exeId: data.exeId, num: data.num, intervalDay: data.intervalDay, describ: data.describ || '' };
          this.formDialogVisible = true;
        } else { this.$message.error(res.message || '获取详情失败'); }
      } catch (error) { this.$message.error('网络错误'); }
    },

    async submitForm() {
      try { await this.$refs.followForm.validate(); } catch (error) { this.$message.warning('请填写完整信息'); return; }
      this.submitLoading = true;
      try {
        let res = this.isEdit ? await followUpdate(this.formData) : await followAdd(this.formData);
        if (res.code === 200 || res.code === 0) {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功');
          this.formDialogVisible = false;
          await this.loadData();
        } else { this.$message.error(res.message || (this.isEdit ? '修改失败' : '新增失败')); }
      } catch (error) { this.$message.error('网络错误'); }
      finally { this.submitLoading = false; }
    },
    handleDialogClose() { this.formData = { id: null, patientId: null, seeId: null, type: null, exeId: null, num: 1, intervalDay: 0, describ: '' }; },

    handleSearch() { this.pageNum = 1; this.loadData(); },
    handleSizeChange(val) { this.pageSize = val; this.pageNum = 1; this.loadData(); },
    handleCurrentChange(val) { this.pageNum = val; this.loadData(); },

    getStatusText(status) { const map = { 1: '未执行', 2: '执行中', 3: '执行完成', 4: '超期' }; return map[status] || '未知'; },
    getStatusType(status) { const map = { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger' }; return map[status] || 'info'; },
    getTypeText(type) { const map = { 1: '复诊提醒', 2: '疗程提醒', 3: '慢病随访', 4: '用药提醒', 5: '其他' }; return map[type] || '未知'; },
    getDoctorNameById(id) { if (!id) return '-'; const doctor = this.doctorOptions.find(item => item.id === id); return doctor ? doctor.label : (id + ''); },
    getGenderText(gender) { const map = { '1': '男', '2': '女', '9': '未说明', '0': '未知' }; return map[gender] || '-'; },
    getOrderTypeText(orderType) { const map = { 0: '西药', 1: '中药', 2: '检查', 3: '检验', 4: '处置', 5: '挂号', 6: '关联处置' }; return map[orderType] || '-'; }
  },
  watch: {
    activeRightTab(newVal) {
      this.handleTabChange(newVal);
    }
  }
};
</script>

<style lang="less" scoped>
.see-info-container {
  height: 100%;
  overflow: auto;
  padding: 12px;
  box-sizing: border-box;
}

.see-info-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  padding: 8px 0;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 12px;
}

.info-item {
  margin-bottom: 12px;
  font-size: 13px;
}

.info-item .label {
  color: #909399;
  margin-right: 8px;
}

.info-item .value {
  color: #303133;
}
.FollowUpManage {
  height: 100%;
  width: 100%;
  background-color: #f5f7fa;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.top-search-box {
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 8px;
}

/* ===== 默认：左右并排（不变） ===== */
.main-layout {
  flex: 1;
  display: flex;
  gap: 8px;
  min-height: 0;
  overflow: hidden;
}

.left-panel {
  width: 45%;
  min-width: 350px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.right-panel {
  flex: 1;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ===== 新增：上下排列 ===== */
.FollowUpManage.vertical-layout {
  .main-layout {
    flex-direction: column;
  }

  /* 随访列表：给多点，比如 2 份 */
  .left-panel {
    width: 100%;
    min-width: 0;
    flex: 2;          /* ← 从 1 改成 2 */
    min-height: 0;
  }

  /* 随访记录：给 1 份 */
  .right-panel {
    width: 100%;
    min-width: 0;
    flex: 1;          /* 保持 1 */
    min-height: 0;
  }
}
/* 修复 left-tabs 高度问题 */
.left-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 修复 right-tabs 高度问题 */
.right-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 修复表格容器 */
.table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;  /* 关键：允许flex子元素收缩 */
}

/* 表格本身占满剩余空间 */
.table-container .el-table {
  flex: 1;
  min-height: 0;
}

/* 分页固定在底部 */
.pagination-wrapper {
  flex-shrink: 0;
  padding: 12px 0 0 0;
  display: flex;
  justify-content: flex-end;
}

.info-form {
  padding: 12px;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.table-wrapper {
  height: 100%;
  overflow: auto;
  padding: 8px;
  box-sizing: border-box;
}

.patient-info-container {
  padding: 12px;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;

  .patient-info-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
  }
}

.empty-tip {
  text-align: center;
  padding: 40px;
  color: #909399;
}

.dialog-footer { text-align: right; }

::v-deep .el-table .cell {
  font-size: 12px;
  text-align: center;
}

::v-deep .el-tabs--border-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  > .el-tabs__header {
    margin: 0;
    flex-shrink: 0;
  }

  > .el-tabs__content {
    flex: 1;
    min-height: 0;         /* 关键：允许 content 收缩 */
    overflow: hidden;
    display: flex;         /* 关键：让 pane 作为 flex 子项 */
    flex-direction: column;
    padding: 0;

    /* Element UI 直接包含 tab-pane，所以这里能覆盖到 */
    > .el-tab-pane {
      flex: 1;
      min-height: 0;       /* 关键中的关键，没有它会被内容撑开 */
      overflow: hidden;    /* 内容超出只在这里裁 */
      display: flex;
      flex-direction: column;
      padding: 8px;
      box-sizing: border-box;
    }
  }
}</style>